let routes = {
    "assetsDir": "/_markup/dist/",
    "compareProducts": "/ajax/compare/products/",
    "clearCompareProducts": "/ajax/compare/clear/",
    "pageCompare": "/ajax/compare/page/",
};

export default routes;